var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import"},[_vm._m(0),_c('UploadCard')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("Upload multiple files")]),_c('li',[_vm._v("Click a button to upload")]),_c('li',[_vm._v("Show the list of uploaded URLs")])])
}]

export { render, staticRenderFns }